module.exports = __webpack_public_path__ + "img/flavor_black_raspberry.9ba37579.png";